/* @flow */
export const FULL_ARCHITECTURE_DESIGN: 'fullArchitectureDesign' = 'fullArchitectureDesign';
export const FULL_HOUSE_DESIGN: 'fullHouseDesign' = 'fullHouseDesign';
export const DESIGN_COUPLE_ROOMS: 'designCoupleRooms' = 'designCoupleRooms';
export const DESIGN_SINGLE_ROOM: 'designSingleRoom' = 'designSingleRoom';
export const HELP_SINGLE_ITEM: 'helpSingleItem' = 'helpSingleItem';
export type ProjectScope =
    | typeof FULL_ARCHITECTURE_DESIGN
    | typeof FULL_HOUSE_DESIGN
    | typeof DESIGN_COUPLE_ROOMS
    | typeof DESIGN_SINGLE_ROOM
    | typeof HELP_SINGLE_ITEM;
